var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tweetStatus"},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.tableData.retry(_vm.scope.row)}}},[_vm._v("授权")]),(_vm.showButton)?_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.tableData.remove(_vm.scope.row,$event)}}},[_vm._v("删除")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }